import React, { useCallback, useContext, useEffect, useState } from "react";
import "./index.less";
import Layout from "../../Layout";
import { useTranslation } from "../../context";
import KnowledgeList from "./pageList";
// import ShortcutList from "../KnowledgeShortcut";
import { Button, message } from "antd";
import ScrollView from "@/baseComponents/ScrollView";
import CreateKnowledgeModal from "../../components/CreateKnowledgeModal";
import api from "../../api";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { useNavigator } from "@/utils/NetworkCheck";

const Knowledge = (props: any) => {
  const lang = useTranslation();
  const [hasCreatePermission, setHasCreatePermission] = useState<boolean>(false);
  const { appRuntimeEnv } = useContext<GlobalContextConfig>(GlobalContext);

  useEffect(() => {
    api.wiki.canCreateWiki().then((res) => {
      const { code, data, status } = res;
      if (code === "200") {
        setHasCreatePermission(data?.includes("FOLDER_CREATE"));
        return;
      } else {
        message.error(status);
        return;
      }
    });
  }, []);

  return (
    <Layout>
      <div className="knowledge-container">
        <div className="joyspace-header">
          <Layout.Breadcrumbs text={lang("knowledge.title")} />
          {hasCreatePermission && (
            <Button
              disabled={!useNavigator.onLine}
              type="primary"
              shape="round"
              className="create-knowledge-button"
              onClick={() => {
                CreateKnowledgeModal({
                  visible: true,
                  appRuntimeEnv
                });
              }}
            >
              新建知识库
            </Button>
          )}
        </div>
        <div className="myspace-list-wrap knowledge-card-ppup-container">
          {/* <ShortcutList /> */}
          <ScrollView nohorizontal={true}>
            <KnowledgeList />
          </ScrollView>
        </div>
      </div>
    </Layout>
  );
};

export default Knowledge;
